import React from 'react';
import FilterComponents from '../../product/components/FilterComponents.tsx';
import CustomDataGrid from '../../components/CustomDataGrid/CustomDataGrid.tsx';

function AddSubscriptinOfferToHomePage(props) {
    const columns = [
        {
            field: 'checkbox',
            headerName: 'Checkbox',
            renderCell: () => <input type="checkbox" />,
        },
        { field: 'name', headerName: 'Name', width: 200 },
        { field: 'restaurantName', headerName: 'Restaurant Name', width: 200 },
        { field: 'duration', headerName: 'Duration', width: 200 },
        { field: 'isactive', headerName: 'IsActive', width: 200 }
    ];

    const dataRows = [
        { id: 1, checkbox: '', name: '10% off at coffee', restaurantName: 'Pot Kettle Black', duration: '10.00 AM to 10.00PM', isactive: 'True', },
        { id: 2, checkbox: '', name: '10% off at Pizza', restaurantName: 'Pot Kettle Black London', duration: '10.00 AM to 10.00PM', isactive: 'True', }
    ];
    return (
        <div>
            <FilterComponents title={"OK"} isItem={10} />
            <CustomDataGrid columns={columns} dataRows={dataRows} />
        </div>
    );
}

export default AddSubscriptinOfferToHomePage;